export default "__VITE_ASSET__BHvrNCjC__"